import { useEffect, useRef } from 'preact/hooks';
import type { RefObject } from 'preact';
import { trapFocus } from '@/lib/focus-trap';

export function useFocusTrap<T extends HTMLElement>(
  ref: RefObject<T>,
  enabled: boolean,
): void {
  const handleRef = useRef<{ release: () => void } | null>(null);
  useEffect(() => {
    const el = ref.current;
    if (!enabled || !el) return;
    handleRef.current = trapFocus(el);
    return () => {
      handleRef.current?.release();
      handleRef.current = null;
    };
  }, [enabled, ref]);
}
